import { render, staticRenderFns } from "./manufacture-edit.vue?vue&type=template&id=21ca7a18&scoped=true&"
import script from "./manufacture-edit.vue?vue&type=script&lang=js&"
export * from "./manufacture-edit.vue?vue&type=script&lang=js&"
import style0 from "./manufacture-edit.vue?vue&type=style&index=0&id=21ca7a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca7a18",
  null
  
)

export default component.exports